module.exports = __webpack_public_path__ + "static/media/app.763e571e.svg";